import Box from '@paperstac/ui/lib/Box';
import Container from '@paperstac/ui/lib/Container';
import Heading from '@paperstac/ui/lib/Heading';
import Link from '@paperstac/ui/lib/Link';
import Text from '@paperstac/ui/lib/Text';
import React from 'react';
import { ReactComponent as Branding } from '../../images/paperstac.svg';

const MaintenanceSplash = React.memo(() => {
  return (
    <Box
      bg="gray.1"
      sx={{
        alignItems: 'center',
        display: 'flex',
        inset: 0,
        justifyContent: 'center',
        position: 'fixed',
        zIndex: 999999,
      }}
    >
      <Container>
        <Box
          sx={{
            bg: 'white',
            border: 'default',
            borderRadius: 'corner',
            boxShadow: 'level2',
            margin: '0 auto',
            maxWidth: 720,
            p: [4, 5, 6],
            textAlign: 'center',
          }}
        >
          <Branding height={34} style={{ marginBottom: 20 }} />
          <Heading as="h1" fontSize={[4, 5]} mb={3}>
            Currently Performing Maintenance
          </Heading>
          <Text fontSize={[2, 3]} mb={3}>
            Paperstac is temporarily unavailable while we complete updates. Please check back shortly.
          </Text>
          <Text color="gray.7">
            Need immediate help?
            <br />
            Contact support at <Link href="mailto:support@paperstac.com">support@paperstac.com</Link> or call{' '}
            <Link sx={{ whiteSpace: 'nowrap' }} href="tel:407-930-9749">
              407-930-9749
            </Link>
            .
          </Text>
        </Box>
      </Container>
    </Box>
  );
});

MaintenanceSplash.propTypes = {};

MaintenanceSplash.defaultProps = {};

MaintenanceSplash.displayName = 'MaintenanceSplash';

export default MaintenanceSplash;
